import { DataBean } from "../DataBean";

export class ModifyLevel extends DataBean {



    public async setAppointmentToEmployeeContract(idContract:any,idAppointment:any,date:any,idEmployee:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "employees.EmployeeContractHistory_setAppointmentToEmployeeContract_Number_Number_java.util.Date_Number", [idContract,idAppointment,date,idEmployee]);
    }
    
}